import { render, staticRenderFns } from "./ConsumptionStats.vue?vue&type=template&id=9da64b36&scoped=true"
import script from "./ConsumptionStats.vue?vue&type=script&lang=js"
export * from "./ConsumptionStats.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionStats.vue?vue&type=style&index=0&id=9da64b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da64b36",
  null
  
)

export default component.exports